<div class="quill-editor-wrapper" [class.readonly-mode]="readOnly" [class.has-error]="hasError">
    <form [formGroup]="reactiveForm">
        <quill-editor formControlName="editorControl" [modules]="quillModules" [theme]="theme"
            [placeholder]="placeholder" [readOnly]="readOnly" [style.height]="height" [style.width]="'100%'"
            (onEditorCreated)="onEditorCreated($event)" (onSelectionChanged)="onSelectionChanged($event)">
        </quill-editor>
    </form>
</div>